import Popups from './popups.js';
import Tabs from './tabs.js';

// Settings
class SiteGlobal {
	// Variables
	static vars = {
		popupsLastFocus: '',
		popupsStack: [],
		windowWidth: Math.max( document.documentElement.clientWidth, window.innerWidth || 0 ),
		windowHeight: Math.max( document.documentElement.clientHeight, window.innerHeight || 0 ),
	};

	// Init
	static init() {
		Popups.init();
		Tabs.init();
		SiteGlobal.initGlobalEvents();
	}

	// Global events
	static initGlobalEvents() {
		// Specific keys press
		document.onkeyup = function( event ) {
			// Handle escape press
			if ( event.keyCode === 27 ) {
				Popups.hide();
			}
		};
	}

	// Bind all events dynamically
	static bindEvent( eventType, selector, callback ) {
		document.addEventListener( eventType, function( e ) {
			const qs = document.querySelectorAll( selector );
			if ( qs ) {
				let el = e.target,
					index = -1;
				while ( el && ( ( index = Array.prototype.indexOf.call( qs, el ) ) === -1 ) ) {
					el = el.parentElement;
				}

				if ( index > -1 ) {
					callback.call( el, e );
				}
			}
		} );
	}

	// To Hex
	static toHex( str ) {
		let result = '';
		for ( let i = 0; i < str.length; i++ ) {
			result += str.charCodeAt( i ).toString( 16 );
		}
		return result;
	}
}

export default SiteGlobal;
